import { Component, h, Host, Prop, State, Watch } from '@stencil/core';


@Component({
    tag: 'lilu-hover-button',
    styleUrl: 'lilu-hover-button.scss',
    shadow: true
})
export class LiluHoverButton {

    @Prop() icon: string;
    @Prop() href: string;
    @Prop() hovered: boolean;

    // Needed for safari, can't detect hover correctly with the :hover selector
    @State() isHover = false;

    @Watch('hovered')
    updateHovered() {
        this.isHover = this.hovered;
    }

    componentWillLoad() {
        this.isHover = this.hovered;
    }

    render() {
        return (
           <Host>
                <a class={`hover-btn ${this.isHover ? 'hover' : ''}`} href={this.href}>
                    <lilu-icon type={this.icon} color="nero" size="size-14 lg-size-16"></lilu-icon>
                    <slot></slot>
                </a>
           </Host>
        );
    }
}
